import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { EntityState } from '../../common/models/index';
import { UserAccount } from '../../session/models/index';
import { jsonDistinctFunction } from './../../common/utils/index';
import { AccountState, getAccountData, getAccountError, getAccountPreferences, getAccountState, accountUpdateAction } from './../store/account.store';

@Injectable()
export class AccountsService {
    constructor(
        private store: Store<AccountState>
    ) { }

    get account$(): Observable<UserAccount> {
        return this.store.select(getAccountData).pipe(distinctUntilChanged(jsonDistinctFunction));
    }
    get state$(): Observable<EntityState> { return this.store.select(getAccountState); }
    get error$(): Observable<any> { return this.store.select(getAccountError); }
    get preferences$(): Observable<{ [key: string]: any }> {
        return this.store.select(getAccountPreferences).pipe(distinctUntilChanged(jsonDistinctFunction));
    }

    update(account: UserAccount): void {
        this.store.dispatch(accountUpdateAction({ account }));
    }

    updatePreferences(preferences: { [key: string]: any }): void {
        this.store.dispatch(accountUpdateAction({ account: { custom_dat: preferences } as UserAccount }));
    }

    setPreferenceByKey(key: string, value: any): void {
        this.store.dispatch(accountUpdateAction({ account: { custom_dat: { [key]: value } } as UserAccount }));
    }

    preferenceByKey$(key: string): Observable<any> {
        return this.preferences$.pipe(map(p => p && p[key]));
    }
}
